import { Fragment } from "react";
import StaedteError from "./Error";

export default function EventMissed( params ) {

    const eventData = params.data;

    let errorOccured = undefined !== eventData.errors;
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === eventData || 0 === eventData.length ) {
        return;
    }

    let eventText = '';
    switch( eventData.event ) {
        case 'BDPL':
            eventText = <>
                <p className="mb-0" style={{fontSize: "1.5em",margin: "0px 0px 20px 0px"}}>
                    <b>
                        {window.staedteFrontendShortcodeData.i18n.missedBeerDiplom}
                    </b>
                </p>
                <p style={{ color:"#5e5e5e"}}>
                    {window.staedteFrontendShortcodeData.i18n.customBeerDiplomText}
                    <br/><br/>
                    {window.staedteFrontendShortcodeData.i18n.customDiplomEvent}
                </p>
            </>
            break;
        case 'CBSC':
            eventText = <>
                <p className="mb-0" style={{fontSize: "1.5em",margin: "0px 0px 20px 0px"}}>
                    <b>
                        {window.staedteFrontendShortcodeData.i18n.missedCocktailBachelor}
                    </b>
                </p>
                <p style={{ color:"#5e5e5e"}}>
                    {window.staedteFrontendShortcodeData.i18n.customCocktailBachelorText}
                    <br/><br/>
                    {window.staedteFrontendShortcodeData.i18n.customBachelorEvent}
                </p>
            </>
            break;
        case 'BBSC':
        default:
            eventText = <>
                <p className="mb-0" style={{fontSize: "1.5em",margin: "0px 0px 20px 0px"}}>
                    <b>
                        {window.staedteFrontendShortcodeData.i18n.missedBeerBachelor}
                    </b>
                </p>
                <p style={{ color:"#5e5e5e"}}>
                    {window.staedteFrontendShortcodeData.i18n.customBeerBachelorText}
                    <br /><br />
                    {window.staedteFrontendShortcodeData.i18n.customBachelorEvent}
                </p>
            </>
        
    }

    return(
        <div style={{marginTop: "50px"}}>

            <div className="">
                {eventText}
            </div>

            <div
                style={{
                    margin: "40px 0px 0px 0px",
                    display: "flex",
                    justifyContent: "center"
                }}
                className="staedte-event-missed-buttons-container"
            >
                <a className="staedte-button-orange" href={'https://www.mybachelor.de'}>
                    {window.staedteFrontendShortcodeData.i18n.stagParty}
                </a>

                <a className="staedte-button-orange" href={'https://www.mybachelor.de'}>
                    {window.staedteFrontendShortcodeData.i18n.companyParty}
                </a>
            </div>

        </div>
    )

}